<script setup lang="ts">
import TitleSkeletonWidget from "@/components/skeleton/widgets/TitleSkeletonWidget.vue";
import InputSkeletonWidget from "@/components/skeleton/widgets/InputSkeletonWidget.vue";
import ToolbarSkeletonWidget from "@/components/skeleton/widgets/ToolbarSkeletonWidget.vue";
</script>

<template>
  <div class="nama-skeleton">
    <TitleSkeletonWidget class="tw-pt-6 tw-px-8"/>
    <ToolbarSkeletonWidget :height="100" class="tw-px-5 tw-pt-1.5 tw-pb-7"/>
    <ToolbarSkeletonWidget :height="45" class="tw-px-5 tw-pb-5"/>
    <InputSkeletonWidget :fields-number="2" class="mobile:tw-hidden tw-px-16"/>
    <InputSkeletonWidget :fields-number="1" class="desktop:tw-hidden tw-px-16"/>
    <ToolbarSkeletonWidget :height="45" class="tw-px-5 tw-pb-5"/>
    <InputSkeletonWidget :fields-number="2" class="mobile:tw-hidden tw-px-16"/>
    <InputSkeletonWidget :fields-number="1" class="desktop:tw-hidden tw-px-16"/>
  </div>
</template>

<style scoped>

</style>
